const styles = {
    // 主容器樣式
    mainContainer: {
        width: '100%',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    
    // 聊天容器樣式
    chatContainer: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        position: 'relative',
    },

    // 訊息顯示區域樣式
    messageArea: {
        flexGrow: 1,
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        padding: '12px 16px 32px 16px',
    },
    
    // 單條訊息樣式（機器人和用戶）
    message: (isBot) => ({
        maxWidth: '100%',
        alignSelf: isBot ? 'flex-start' : 'flex-end',
        fontFamily: 'Noto Sans',
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '20px',
        textAlign: 'left',
        color: '#333333',
    }),

    
    // 訊息內容樣式
    messageContent: (isBot) => ({
        padding: '8px',
        fontSize: '14px',
        lineHeight: '20px',
        fontWeight: 400,
        bgcolor: isBot ? '#EEEEEE' : '#42A5F5',
        borderRadius: isBot ? '0 10px 10px 10px' : '10px 0 10px 10px',
        color: isBot ? 'inherit' : 'white',
    }),
    
    // 時間戳樣式
    timestamp: {
        color: 'text.secondary',
    },
    
    // 反饋按鈕樣式
    feedbackButtons: {
        display: 'flex',
        '& > button': {
            padding: 0,
        },
    },
    
    // 推薦問題按鈕樣式
    recommendedQuestion: {
        fontSize: '14px',
        fontWeight: 400,
        textAlign: 'left',
        maxWidth: '100%',
        borderRadius: '18px',
        borderColor: '#2382FE',
        color: '#2382FE',
        '&:hover': {
            bgcolor: '#e3f2fd',
            borderColor: '#2382FE',
        },
    },
    
    // 重置按鈕樣式
    resetButton: {
        fontSize: '14px',
        fontWeight: 400,        
        position: 'fixed',
        bottom: '76px',
        left: '50%',
        transform: 'translateX(-50%)',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        color: '#999999'
    },
    
    // 重置文字樣式
    resetText: {
        cursor: 'pointer',
        textDecoration: 'underline',
        fontSize: '14px',
        fontWeight: 400,
    },
    
    // 輸入區域樣式
    inputArea: {
        p: 2,
        bgcolor: '#ffffff',
        display: 'flex',
        alignItems: 'center',
    },
    
    // 輸入區域 inputField 樣式
    inputField: {
        bgcolor: 'white',
        '& .MuiInputBase-input': {
            fontFamily: 'Noto Sans', // 設置字體
            fontSize: '14px', // 調整字體大小
            fontWeight: 400, // 設置字體粗細
            lineHeight: '20px', // 設置行高
            textAlign: 'left', // 設置文本對齊方式
            padding: '0px 10px', // 覆蓋內邊距
            height: '40px', // 覆蓋高度
            boxSizing: 'border-box', // 新增 box-sizing
        },
        '& .MuiOutlinedInput-root': {
            padding: '0px', // 新增 padding
            height: '40px', // 覆蓋高度
            backgroundColor: '#FFFFFF', // 新增背景顏色
            '& fieldset': {
                borderColor: '#CCCCCC', // 新增邊框顏色
                borderWidth: '1px', // 新增邊框寬度
            },
            '&:hover fieldset': {
                borderColor: '#CCCCCC', // 新增滑鼠懸停時的邊框顏色
            },
            '&.Mui-focused fieldset': {
                borderColor: '#CCCCCC', // 新增聚焦時的邊框顏色
                borderWidth: '1px', // 保持聚焦時的邊框寬度
            },
        },
        '& .MuiInputAdornment-root': {
            marginRight: 0, // 移除 InputAdornment 的右側 margin
        },
        '& .MuiInputBase-input::placeholder': {
            fontFamily: 'Noto Sans', // 新增字體
            fontSize: '14px', // 新增字體大小
            fontWeight: 400, // 新增字體粗細
            lineHeight: '20px', // 新增行高
            textAlign: 'left', // 新增文本對齊方式
            color: '#CCCCCC', // 新增顏色
            opacity: 1, // 新增透明度
        },
    },


    sendButton: {
        padding: 0, // 移除按鈕內邊距
    },
};

export default styles;
